import { ReactNode } from "react";
import tw from "src/utils/tw";

interface Props {
  children: ReactNode;
  className?: string;
}

export default function Breadcrumbs(props: Props) {
  return (
    <div
      className={tw("truncate pt-2 text-sm", props.className)}
      css={{
        ["& a"]: {
          fontWeight: "bold",
        },
      }}
    >
      {props.children}
    </div>
  );
}
